import { apiPost, apiPostForm } from './api';

export function sendEmail(payload) {
  return apiPost('/api/emailService/send-email', payload);
}

export function verifyRecipientCsv(file) {
  const formData = new FormData();
  formData.append('file', file);
  return apiPostForm('/api/emailService/verify-recipients-csv', formData);
}

export async function createDispatchJob(payload, files = []) {
  const formData = new FormData();

  if (Array.isArray(payload.senderIds) && payload.senderIds.length > 0) {
    formData.append('senderIds', JSON.stringify(payload.senderIds));
  } else if (payload.senderId != null) {
    formData.append('senderId', String(payload.senderId));
  }
  formData.append('subject', payload.subject);
  formData.append('text', payload.text);
  if (payload.html) {
    formData.append('html', payload.html);
  }
  if (payload.sendAt) {
    formData.append('sendAt', payload.sendAt);
  }
  formData.append('recipients', JSON.stringify(payload.recipients || []));

  for (const file of files) {
    formData.append('attachments', file);
  }

  // apiPostForm already returns response.data.data
  return apiPostForm('/api/emailService/dispatch-job', formData);
}
